import dynamic from 'next/dynamic'
import { TimeLineContextProvider } from '../../contexts'
import { BigBrotherProvider } from '../../contexts/providers/BigBrotherProvider'
import {
  IPage,
  isArticlePage,
  isArticlePageFl,
  isArticleTimeLinePage,
  isArticleTimeLinePageFL,
  isAuthorCategoryTagPage,
  isAuthorCategoryTagPageFl,
  isGridVodPage,
  isHomepage,
  isLiveVodPage,
  isNewsFlashesPage,
  isRecipePage,
  isTVGuidePage,
  isVodPage,
} from '../../types'
import { AuthorCategoryTag } from './AuthorCategoryTag'

const NewsFlashesPage = dynamic(() => import('./NewsFlashesPage'), {
  ssr: true,
})
const LiveVod = dynamic(() => import('./LiveVod'), { ssr: true })
const Article = dynamic(() => import('./Article/Article'), { ssr: true })
const Recipe = dynamic(() => import('./ArticleRecipe'), { ssr: true })
const ArticleTimeLine = dynamic(() => import('./ArticleTimeLine'), {
  ssr: true,
})
const GridVodPage = dynamic(() => import('./GridVod'), { ssr: true })

const ArticleTimeLineFL = dynamic(() => import('./ArticleTimeLineFL'), {
  ssr: true,
})
const AuthorCategoryTagFl = dynamic(() => import('./AuthorCategoryTagFl'), {
  ssr: true,
})
const TVGuide = dynamic(() => import('./TVGuide'), { ssr: true })
const VodPage = dynamic(() => import('./VodPage'), { ssr: true })
const ArticleFl = dynamic(() => import('./ArticleFl'), { ssr: true })

export const renderPage = (page: IPage) => {
  if (!page) {
    console.log(
      '%cPageLayout :161',
      'background-color:yellow;color:black;padding:2px 5px;',
      'PageLayout: unknown page type',
      page
    )
    return
  }

  if (isAuthorCategoryTagPage(page)) {
    return <AuthorCategoryTag page={page} isHomepage={isHomepage(page)} />
  }
  if (isAuthorCategoryTagPageFl(page)) {
    return <AuthorCategoryTagFl page={page} isHomepage={isHomepage(page)} />
  }
  if (isArticlePage(page)) {
    if (isRecipePage(page)) {
      return <Recipe page={page} />
    }
    if (isArticleTimeLinePage(page)) {
      return (
        <TimeLineContextProvider>
          <BigBrotherProvider>
            <ArticleTimeLine page={page} />
          </BigBrotherProvider>
        </TimeLineContextProvider>
      )
    }
    return <Article page={page} />
  }
  if (isArticlePageFl(page)) {
    if (isRecipePage(page)) {
      return <Recipe page={page} />
    }
    if (isArticleTimeLinePage(page)) {
      return (
        <TimeLineContextProvider>
          <ArticleTimeLine page={page} />
        </TimeLineContextProvider>
      )
    }
    if (isArticleTimeLinePageFL(page)) {
      return (
        <TimeLineContextProvider>
          <ArticleTimeLineFL page={page} />
        </TimeLineContextProvider>
      )
    }
    return <ArticleFl page={page} />
  }
  if (isNewsFlashesPage(page)) {
    return <NewsFlashesPage page={page} />
  }
  if (isTVGuidePage(page)) {
    return <TVGuide page={page} />
  }
  if (isLiveVodPage(page)) {
    return <LiveVod page={page} key={'LiveVod'} />
  }
  if (isVodPage(page)) {
    return <VodPage page={page} />
  }
  if (isGridVodPage(page)) {
    return <GridVodPage page={page} />
  }
  return null
}
